// İSG Portal — Input primitifi. Token'lı stil; hata durumu `aria-invalid`.

import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from './cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-10 w-full rounded-md border bg-surface px-3 text-sm text-fg',
        'placeholder:text-muted transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-60',
        // carbon: (Stage 2 "Input/Select/Textarea") — alt-çizgi kontrol: köşesiz, yalnız
        // alt kenarlık, odak halkası İÇE (`ring-inset`, tokens.css §2.2'nin -2px'iyle eşleşir).
        // `pl-4`/`pr-4` AYRI (`px-4` DEĞİL) — bir çağıran (ör. `TableToolbar`'ın arama kutusu,
        // sol tarafta ikon için) yalnız `carbon:pl-*`'ı override ETMEK isteyebilir; `px-4`
        // kısayolu olsaydı `cn()`/`twMerge` onu yalnız AYNI grup (`pl`) çakışmasıyla eşleştirip
        // TÜMÜNÜ (sağ dahil) silerdi ya da (variant'lı sürümlerde) hiç eşleştirmeyip iki kuralı
        // da bırakır, kazananı Tailwind'in üretim SIRASINA bırakırdı — bu tam olarak
        // `TableToolbar`'da ikon/metin üst üste binmesine yol açan defektti.
        'carbon:rounded-none carbon:border-0 carbon:border-b carbon:pl-4 carbon:pr-4 carbon:focus-visible:ring-inset',
        'carbon:placeholder:text-placeholder',
        // `[data-tile]` atası (Card/Modal, S33 Slice 6 global düzeltme #2) ALTINDA gri dolgu —
        // beyaz Tile'da beyaz `bg-surface` kontrolü GÖRÜNMEZ olurdu (`theme-carbon.css`'in
        // `--color-field` yorumu, `Modal.tsx`'in footer grid işareti `data-modal-footer`
        // deseniyle AYNI DOM-kapsam mekanizması). Tile DIŞINDA (gri sayfa zemininde) bu kural
        // HİÇ eşleşmez, `bg-surface` (beyaz) kalır.
        'carbon:[[data-tile]_&]:bg-field',
        invalid
          ? 'border-danger focus-visible:ring-danger carbon:border-b-danger'
          : 'border-border-strong carbon:border-b-border-strong',
        className,
      )}
      {...props}
    />
  );
});
